import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { todayZurich } from "@/lib/format";
import { Field } from "@/components/Field";
import { FormDialog, useSubmit, num, clean } from "./FormDialog";

export const PurchasedDialog = ({ open, onOpenChange, item, onSaved }) => {
  const [f, setF] = useState({});
  const { saving, run } = useSubmit();
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  useEffect(() => {
    if (open) setF({ actual_cost: "", store: item?.store || "", purchased_on: todayZurich(), receipt: "" });
  }, [open, item]);

  const submit = () =>
    run(async () => {
      await api.post(`/shopping/${item.id}/purchased`, clean({ ...f, actual_cost: num(f.actual_cost) }));
      onOpenChange(false);
      onSaved?.();
    }, "Segnato come acquistato");

  return (
    <FormDialog open={open} onOpenChange={onOpenChange} title="Ho acquistato" description={item?.name} onSubmit={submit} saving={saving} testId="purchased-dialog" submitLabel="Conferma acquisto">
      <div className="grid grid-cols-2 gap-3">
        <Field label="Prezzo pagato (CHF)"><Input data-testid="purchased-cost-input" type="number" min="0" step="0.05" value={f.actual_cost} onChange={set("actual_cost")} className="h-11" /></Field>
        <Field label="Data"><Input data-testid="purchased-date-input" type="date" value={f.purchased_on} onChange={set("purchased_on")} className="h-11" /></Field>
      </div>
      <Field label="Negozio"><Input data-testid="purchased-store-input" value={f.store} onChange={set("store")} className="h-11" /></Field>
      <Field label="Scontrino" hint="Numero o riferimento. Il caricamento della foto arriverà con la gestione allegati."><Input data-testid="purchased-receipt-input" value={f.receipt} onChange={set("receipt")} className="h-11" /></Field>
    </FormDialog>
  );
};
